import React from 'react';
import { LineHelper } from '../../../../helpers/line.helper';
import { ILine } from '../../../../models/line.model';
import { TranslationService } from '../../../../services/translation.service';

export default function LineBadge({ line, className = '' }: { line: ILine; className?: string }): React.ReactNode {
  return (
    <span
      className={`px-1 flex-shrink-0 rounded border d-flex align-items-center justify-content-center ${className ?? ''}`}
      style={{
        minHeight: '1.5rem',
        minWidth: '1.5rem',
        lineHeight: '1rem',
        backgroundColor: LineHelper.getBackgroundColor(line),
        color: LineHelper.getForegroundColor(line),
        borderColor: LineHelper.getBorderColor(line),
      }}
    >
      <span className="visually-hidden">{TranslationService.get('common.line')}</span>
      {line.name ? <span className="fw-bold small">{line.name}</span> : <span className="fw-bold small">{line.shortName}</span>}
    </span>
  );
}
